import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { useEffect } from "react";

function AnonymousRoutes() {
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  useEffect(() => {
    console.log("AnnoRoute", isAuthenticated);
  }, [isAuthenticated]);

  return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
}
export default AnonymousRoutes;
